import DialogContent from '@zenbusiness/zui/DialogContent';
import { styled } from '@zenbusiness/zui/styles';

export const OptionButtonStyle = {
  borderRadius: 3,
  '&.MuiButton-sizeSmall': {
    padding: '10px'
  }
};

export const DialogContentStyles = () => ({
  padding: '0'
});

export const DialogContentStyled = styled(DialogContent)(DialogContentStyles);
